import request from '@/utils/request';
import ZaToast from '@/components/ZaToast';
export function saveOrder(data) {
  return request('/order/saveOrder', {
    method: 'POST',
    data
  });
} // 查询订单详情

export function getOrderDetail(data) {
  data.needAllInsured = true;
  return request('/v1/insure/queryOrderDetail', {
    method: 'POST',
    data
  }).then(res => {
    if (!res.success) ZaToast.show(res.message);
    return res;
  });
} // 查询订单结果

export function queryPolicyInfo(params) {
  return request('/v1/insure/queryPolicyDetail', {
    method: 'POST',
    data: params
  });
} // 获取跳转url

export function getQueryPayNextUrl(data) {
  return request('/v1/insure/queryQueryPayNextUrl', {
    method: 'POST',
    data
  });
}
export function queryOrderByOrderNoForShow(data) {
  return request('/order/face/queryOrderByOrderNoForShow', {
    method: 'POST',
    data
  });
}
export function queryOrderStatus(data) {
  return request('/order/queryOrderStatus', {
    method: 'POST',
    data
  });
}
export function getPolicyResult(data) {
  return request('/order/queryPolicyResult', {
    method: 'POST',
    data
  });
}
export function pay(data) {
  return request('/order/pay/confirm', {
    method: 'POST',
    data
  });
} // 查收是否是南网员工
// order/EcifQuery/isECIFStaff

export function checkSouthNetworkStaff(data) {
  return request('/order/EcifQuery/isECIFStaff', {
    method: 'POST',
    data,
    failMuted: true,
    errorMuted: true
  });
}
/**
 * 出单
 * @param {Object} params
 * userId: 'string',
 * currentPage: 0,
 * goodsId: 0,
 */

export function autoCommonPolicy(data) {
  return request('/order/policy/autoCommonPolicy', {
    method: 'POST',
    data
  });
}
/**
 * 保费计算
 * @param {Object} params
 */

export function getPremium(data) {
  /*
  {
    "goodsId": "",
    "planId": "",
    "premiumCalculatePackageList": [{
      "productPackageId": "",
      "premiumFactorList": [{
        "type": "0",
        "code": "",
        "value": ""
      }],
      "premiumCalculateProductList": [{
        "productId": "",
        "sumInsured": 0,
        "premiumCalculateLiabilityList": [{
            "liabilityCode": "",
            "sumInsured": 0
          }]
        }]
    }]
    }
  */
  return request('/order/premiumCalculate/getPremium', {
    method: 'POST',
    data,
    failMuted: true
  });
}